import React, {Component} from "react";
import {connect} from "react-redux";
import {DatePicker, List, Picker, Toast} from "antd-mobile";
import './PepairApply.css';
import {API} from "../../configs/api.config";
import UploadEnclosure from "../../components/UploadEnclosure";
import {Button} from "antd";
import {getIntValue, getStrValue, isObjEmpty} from "../../utils/common";
import moment from "moment";
import {fetchGet, fetchPost} from "../../utils/fetchRequest";
import TargetSelect from "../../components/TargetSelect";


class RepairApply extends Component {
    componentWillMount() {
        document.title = "物业维修申请";
    }

    componentDidMount() {
        this.node.scrollIntoView();
        this.getOrganization()
    }

    constructor(props) {
        super(props);
        this.state = {
            targetData: [],
            fileList: [], //附件
            typeLeave: [
                {
                    label: '电器',
                    value: '1'
                }, {
                    label: '水闸',
                    value: '2'
                }, {
                    label: '门窗',
                    value: '3'
                }, {
                    label: '器材',
                    value: '4'
                }, {
                    label: '其他',
                    value: '5'
                }
            ],
            scrapTime: null, // 报修日期
            repairSite: null, // 维修地点
            faultReason: null, // 故障描述
            notifier: [], //接收人
        };
    }

    render() {

        const targetProps = {
            targetData: this.state.targetData,
            targetValues: this.state.targetList,
            title: '接收人',
            targetCount: this.state.targetCount,
            onTargetChange: this.onTargetChange.bind(this),
            onTargetFocus: this.onTargetFocus.bind(this),
            multiple: false,
        }

        const defaultTargetProps = {
            targetData: [],
            targetValues: this.state.targetList,
            title: '接收人',
            targetCount: this.state.targetCount,
            onTargetChange: this.onTargetChange.bind(this),
            onTargetFocus: this.onTargetFocus.bind(this),
            multiple: false,
        }

        return (
            <div className="common-column-layout" ref={node => this.node = node} onChange={this.handelValueCom} style={{fontFamily:"PingFangSC-Regular",letterSpacing:2.5}}>
                <DatePicker
                    value={this.state.scrapTime}
                    locale={{
                        okText: '确定',
                        dismissText: '取消'
                    }}
                    onChange={date => this.setState({scrapTime: date})}>
                    <List.Item arrow="horizontal">报修日期</List.Item>
                </DatePicker>

                <div className="comhline_sty1"></div>

                <div className="item_sty">
                    <div className="left_title">维修地点</div>
                    <input ref='repairSite' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.repairSite}/>
                </div>

                <div className="comhline_sty"></div>

                <div>
                    <textarea  ref='faultReason' className="form-control textarea_sty" rows="4"
                               placeholder="故障描述" maxLength={100}></textarea>
                </div>

                <div className="comhline_sty"></div>

                {this.state.targetData.length > 0 ? <TargetSelect {...targetProps}/>
                    : <TargetSelect {...defaultTargetProps}/>}

                <div className="comhline_sty"></div>

                <UploadEnclosure
                    action={API.UPLOAD_FILE}
                    fileList={this.state.fileList}
                    count={9}
                    multiple={true}
                    beforeUpload={this.beforeUpload.bind(this)}
                    handleChange={this.handleChange.bind(this)}
                />
                <Button className='commonButton' type='primary' style={{margin: '35px',borderRadius:30}}
                        onClick={this.onSubmitClick}>提交</Button>
            </div>
        )
    }

    onSubmitClick = (event) => {
        if(this.isRequesting == true){
            return
        }

        if (this.state.scrapTime == null || this.state.scrapTime == '') {
            Toast.fail('请输入报修时间！')
            return
        }

        if (this.state.repairSite == null || this.state.repairSite.trim().length == 0) {
            Toast.show('请填写维修地点',1);
            return
        }

        if (this.state.faultReason == null || this.state.faultReason == '') {
            Toast.fail('请填写损坏描述');
            return
        }

        const approveFiles = [];
        if (this.state.fileList) {
            this.state.fileList.forEach((value, index) => {
                // approveFiles.push(value.thumbUrl)
                approveFiles.push(value.picUrl)
            })
        }

        if (!isObjEmpty(this.checkNodes)) {
            this.checkNodes.forEach((node, index) => {
                this.state.notifier.push(node.userId)
            })
        } else {
            Toast.fail('请选择接收人')
            return
        }

        const params = {
            approveTitle: this.state.repairSite,
            approveDetails: this.state.faultReason,
            teacherId: this.props.userInfo.teacher.teacherId,
            // proposer: this.props.userInfo.user.userFunId,
            approveStatus:0,
            approveFiles: JSON.stringify(approveFiles),
            scrapDate: moment(this.state.scrapTime).format('YYYY-MM-DD HH:mm:ss'),
            notifiers:JSON.stringify(this.state.notifier),
        };

        console.log('param', params);
        this.isRequesting = true;
        fetchPost(API.brokenCreate, {
            maString:JSON.stringify(params)
        }, {}).then((response) => {
            console.log('response', response);
            this.isRequesting = false;
            if (response.success) {
                this.isRequesting = true;
                Toast.show(response.data, 1);
                // this.props.history.push("/leaveList/" + this.props.match.params.role)
                // this.props.history.push("/homePage")
                this.backTask = setTimeout(() => {
                    this.props.history.goBack()
                }, 1000)
            }
        }).catch((error) => {
            this.isRequesting = false;
            console.log('error', error);
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    };

    beforeUpload = (file, fileList) => {

    };

    handleChange = fileList => {
        if (fileList) {
            this.setState({fileList})
        }
    };

    getOrganization = () => {
        Toast.loading('', 0);

        fetchGet(API.getProperty, {
            schoolId: this.props.userInfo.teacher.schoolId,
            // schoolId:1
        }).then(response => {
            Toast.hide();
            const {targetData} = this.state;
            targetData.length = 0;
            if (response && response.data) {
                // const schoolArray = response.data.schools
                const propertyArray = response.data;

                if (!isObjEmpty(propertyArray)) {
                    const propertyData = [];
                    propertyArray.forEach((hrObj, index) => {
                        if (hrObj) {
                            propertyData.push({
                                title: getStrValue(hrObj, 'name'),
                                userId: getIntValue(hrObj, 'id'),
                                userPhone: getStrValue(hrObj, 'phone'),
                                value: getStrValue(hrObj, 'name') + `-0-${index}`,
                                key: `0-${index}`,
                            })
                        }
                    });

                    targetData.push({
                        title: `全体物业人员`,
                        value: `0`,
                        key: `0`,
                        selectable:false,
                        children: propertyData,
                    })
                }
            }

            console.log('targetData', targetData);
            this.setState({
                targetData,
            })
        }).catch(error => {
            Toast.hide();

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    };

    onTargetFocus = (e) => {
        if (isObjEmpty(this.state.targetData)) {
            this.getOrganization()
        }
    }

    onTargetChange = (value, label, checkNodes, count) => {
        this.checkNodes = checkNodes;
        this.setState({
            targetList: value,
            targetCount: count
        });
    };

    handelValueCom = (event) => {
        //获取用户名的值
        let repairSite = this.refs.repairSite.value;
        let faultReason = this.refs.faultReason.value;
        //获得内容的值
        this.setState({
            repairSite: repairSite,
            faultReason: faultReason,
        })
    }

}
let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo}
});

let mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(RepairApply)